import { render, staticRenderFns } from "./trxlist.vue?vue&type=template&id=39b88e16"
import script from "./trxlist.vue?vue&type=script&lang=js"
export * from "./trxlist.vue?vue&type=script&lang=js"
import style0 from "./trxlist.vue?vue&type=style&index=0&id=39b88e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports